export const sessionChangedError = () => {
    const error = new Error('This tab has an older session. Reload before continuing.');
    error.code = 'ERR_SESSION_CHANGED';
    return error;
};

// Protect the configured API only; public sign-in/registration establish a session.
export function installSessionSafety({ client, api, getSession, checkSession, invalidate }) {
    const apiUrl = new URL(api, window.location.href);
    const basePath = apiUrl.pathname.replace(/\/$/, '');
    const snapshots = new WeakMap();
    const isProtected = config => {
        const url = new URL(client.getUri(config), window.location.href);
        return url.origin === apiUrl.origin &&
            (url.pathname === basePath || url.pathname.startsWith(`${basePath}/`)) &&
            ![`${basePath}/auth/login`, `${basePath}/auth/register`].includes(url.pathname);
    };
    const requestId = client.interceptors.request.use(config => {
        if (!isProtected(config)) return config;
        if (!checkSession()) throw sessionChangedError();
        const session = getSession();
        const authorization = config.headers.get('Authorization');
        if ((authorization || null) !== (session.token ? `Bearer ${session.token}` : null)) {
            invalidate();
            throw sessionChangedError();
        }
        snapshots.set(config, session.version);
        return config;
    }, error => { throw error; }, { synchronous: true });

    const checkResponse = config => {
        if (!config || !snapshots.has(config)) return;
        // An old response must not invalidate a newer login in this same tab.
        if (snapshots.get(config) !== getSession().version || !checkSession()) {
            throw sessionChangedError();
        }
    };
    const responseId = client.interceptors.response.use(response => {
        checkResponse(response.config);
        return response;
    }, error => {
        checkResponse(error.config);
        return Promise.reject(error);
    });
    return () => {
        client.interceptors.request.eject(requestId);
        client.interceptors.response.eject(responseId);
    };
}
